import Vue from 'vue';
import VueRouter from 'vue-router';
import RouterPrefetch from 'vue-router-prefetch';
import Intro from '../views/Home/Intro.vue';
import Home from '../views/Home/Home.vue';

Vue.use(VueRouter);
Vue.use(RouterPrefetch);

const routes = [
  {
    path: '/',
    name: 'Intro',
    component: Intro
  },
  {
    path: '/home',
    name: 'Home',
    component: Home
  },
  {
    path: '/home/the-stadium',
    name: 'The Stadium',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "home" */ '../views/Home/TheStadium.vue')
  },
  {
    path: '/home/highlight',
    name: 'The Stadium Highlight',    
    component: () => import(/* webpackChunkName: "home" */ '../views/Home/End.vue')
  },
  {
    path: '/las-vegas-market',
    name: 'Las Vegas Market',    
    component: () => import(/* webpackChunkName: "las-vegas-market" */ '../views/LasVegasMarket/LasVegasMarket.vue')
  },
  {
    path: '/las-vegas-market/las-vegas',
    name: 'Las Vegas',    
    component: () => import(/* webpackChunkName: "las-vegas-market" */ '../views/LasVegasMarket/LasVegas.vue')
  },
  {
    path: '/las-vegas-market/tourism',
    name: 'Tourism',    
    component: () => import(/* webpackChunkName: "las-vegas-market" */ '../views/LasVegasMarket/Tourism.vue')
  },
  {
    path: '/las-vegas-market/entertainment',
    name: 'Entertainment',    
    component: () => import(/* webpackChunkName: "las-vegas-market" */ '../views/LasVegasMarket/Entertainment.vue')
  },
  //{
    //path: '/las-vegas-market/ticket-sales',
    //name: 'Ticket Sales',    
    //component: () => import(/* webpackChunkName: "las-vegas-market" */ '../views/LasVegasMarket/TicketSales.vue')
  //},  
  {
    path: '/las-vegas-market/routing',
    name: 'Routing',    
    component: () => import(/* webpackChunkName: "las-vegas-market" */ '../views/LasVegasMarket/Routing.vue')
  },
  {
    path: '/las-vegas-market/highlight',
    name: 'Why Las Vegas Highlight',    
    component: () => import(/* webpackChunkName: "las-vegas-market" */ '../views/LasVegasMarket/End.vue')
  },
  {
    path: '/event-production',
    name: 'Event Production',    
    component: () => import(/* webpackChunkName: "event-production" */ '../views/EventProduction/EventProduction.vue')
  },
  {
    path: '/event-production/seamless-load-in-load-out',
    name: 'Seamless Load In/Out',    
    component: () => import(/* webpackChunkName: "event-production" */ '../views/EventProduction/SeamlessLoad.vue')
  },
  {
    path: '/event-production/seamless-load-in-load-out-highlights',
    name: 'Seamless Load In/Out Highlights',    
    component: () => import(/* webpackChunkName: "event-production" */ '../views/EventProduction/SeamlessLoadHighlights.vue')
  },
  {
    path: '/event-production/cost-savings',
    name: 'Cost Savings',    
    component: () => import(/* webpackChunkName: "event-production" */ '../views/EventProduction/CostSavings.vue')
  },
  {
    path: '/event-production/back-of-house',
    name: 'Back of House',    
    component: () => import(/* webpackChunkName: "event-production" */ '../views/EventProduction/BackOfHouse.vue')
  },
  {
    path: '/event-production/backstage-map',
    name: 'Backstage Map',    
    component: () => import(/* webpackChunkName: "event-production" */ '../views/EventProduction/BackstageMap.vue')
  },
  {
    path: '/event-production/stage-configurations',
    name: 'Stage Configurations',    
    component: () => import(/* webpackChunkName: "event-production" */ '../views/EventProduction/StageConfigurations.vue')
  },
  {
    path: '/event-production/highlight',
    name: 'Event Production Highlight',    
    component: () => import(/* webpackChunkName: "event-production" */ '../views/EventProduction/End.vue')
  },
  {
    path: '/features-and-amenities',
    name: 'Feaures & Amenities',    
    component: () => import(/* webpackChunkName: "features-and-amenitites" */ '../views/FeaturesAndAmenities/FeaturesAndAmenities.vue')
  },
  {
    path: '/features-and-amenities/leading-edge-technology',
    name: 'Leading Edge Technology',    
    component: () => import(/* webpackChunkName: "features-and-amenitites" */ '../views/FeaturesAndAmenities/LeadingEdgeTechnology.vue')
  },
  {
    path: '/features-and-amenities/leading-edge-technology/streaming-capabilities',
    name: 'Streaming Capabilities',    
    component: () => import(/* webpackChunkName: "features-and-amenitites" */ '../views/FeaturesAndAmenities/StreamingCapabilities.vue')
  },
  {
    path: '/features-and-amenities/leading-edge-technology/wifi-and-cell-coverage',
    name: 'Wi-Fi & Cell Coverage',    
    component: () => import(/* webpackChunkName: "features-and-amenitites" */ '../views/FeaturesAndAmenities/WiFiAndCellCoverage.vue')
  },  
  {
    path: '/features-and-amenities/leading-edge-technology/cashless-payment',
    name: 'Cashless Payment',    
    component: () => import(/* webpackChunkName: "features-and-amenitites" */ '../views/FeaturesAndAmenities/CashlessPayment.vue')
  },  
  {
    path: '/features-and-amenities/ticketing',
    name: 'Ticketing',    
    component: () => import(/* webpackChunkName: "features-and-amenitites" */ '../views/FeaturesAndAmenities/Ticketing.vue')
  },
  {
    path: '/features-and-amenities/etfe-roof',
    name: 'ETFE Roof',    
    component: () => import(/* webpackChunkName: "features-and-amenitites" */ '../views/FeaturesAndAmenities/EtfeRoof.vue')
  },
  {
    path: '/features-and-amenities/artist-vip-activations',
    name: 'Artist VIP Activations',    
    component: () => import(/* webpackChunkName: "features-and-amenitites" */ '../views/FeaturesAndAmenities/ArtistVipActivations.vue')
  },
  {
    path: '/features-and-amenities/highlight',
    name: 'Features & Amenities Highlight',    
    component: () => import(/* webpackChunkName: "features-and-amenitites" */ '../views/FeaturesAndAmenities/End.vue')
  },
  {
    path: '/marketing',
    name: 'Marketing',    
    component: () => import(/* webpackChunkName: "marketing" */ '../views/Marketing/Marketing.vue')
  },
  {
    path: '/marketing/services',
    name: 'Services',    
    component: () => import(/* webpackChunkName: "marketing" */ '../views/Marketing/Services.vue')
  },
  {
    path: '/marketing/in-game-activations',
    name: 'In-Game Activations',    
    component: () => import(/* webpackChunkName: "marketing" */ '../views/Marketing/InGameActivations.vue')
  },
  {
    path: '/marketing/venue-assets',
    name: 'Venue Assets',    
    component: () => import(/* webpackChunkName: "marketing" */ '../views/Marketing/VenueAssets.vue')
  },
  {
    path: '/marketing/digital-marketing-assets',
    name: 'Digital Marketing Assets',    
    component: () => import(/* webpackChunkName: "marketing" */ '../views/Marketing/DigitalMarketingAssets.vue')
  },
  //{
//    path: '/marketing/partnership-marketing',
    //name: 'Partnership Marketing',    
    //component: () => import(/* webpackChunkName: "marketing" */ '../views/Marketing/PartnershipMarketing.vue')
  //},
  {
    path: '/marketing/highlight',
    name: 'Marketing Highlight',    
    component: () => import(/* webpackChunkName: "marketing" */ '../views/Marketing/End.vue')
  },
  {
    path: '/getting-to-the-show',
    name: 'Getting To The Show',    
    component: () => import(/* webpackChunkName: "getting-to-the-show" */ '../views/GettingToTheShow/GettingToTheShow.vue')
  },
//{
//    path: '/getting-to-the-show/transportation-plan',
//    name: 'Transportation Plan',    
//    component: () => import(/* webpackChunkName: "getting-to-the-show" */ '../views/GettingToTheShow/TransportationPlan.vue')
//},
  {
    path: '/getting-to-the-show/walkable-from-strip',
    name: 'Walkable From Strip',    
    component: () => import(/* webpackChunkName: "getting-to-the-show" */ '../views/GettingToTheShow/WalkableFromStrip.vue')
  },
  {
    path: '/getting-to-the-show/hacienda-bridge',
    name: 'Hacienda Bridge',    
    component: () => import(/* webpackChunkName: "getting-to-the-show" */ '../views/GettingToTheShow/HaciendaBridge.vue')
  },
  //ADD PAGE CALLED VIDEO
  {
    path: '/getting-to-the-show/parking-rideshare-and-taxi',
    name: 'Parking, Rideshare & Taxi',    
    component: () => import(/* webpackChunkName: "getting-to-the-show" */ '../views/GettingToTheShow/ParkingRideshareTaxi.vue')
  },
  {
    path: '/getting-to-the-show/travel',
    name: 'Travel',    
    component: () => import(/* webpackChunkName: "getting-to-the-show" */ '../views/GettingToTheShow/Travel.vue')
  },
  {
    path: '/getting-to-the-show/highlight',
    name: 'Getting To The Show Highlight',    
    component: () => import(/* webpackChunkName: "getting-to-the-show" */ '../views/GettingToTheShow/End.vue')
  },
  {
    path: '/gallery',
    name: 'Gallery',    
    component: () => import(/* webpackChunkName: "gallery" */ '../views/Gallery/Gallery.vue')
  },
  {
    path: '/gallery/videos',
    name: 'Videos',    
    component: () => import(/* webpackChunkName: "gallery" */ '../views/Gallery/Videos.vue')
  },
  {
    path: '/gallery/exterior',
    name: 'Exterior Photo Gallery',    
    component: () => import(/* webpackChunkName: "gallery" */ '../views/Gallery/Exterior.vue')
  },
  {
    path: '/gallery/exterior/stadium',
    name: 'Exterior Stadium Photo Gallery',    
    component: () => import(/* webpackChunkName: "gallery" */ '../views/Gallery/Stadium.vue')
  },
  {
    path: '/gallery/exterior/load-in',
    name: 'Exterior Load In Photo Gallery',    
    component: () => import(/* webpackChunkName: "gallery" */ '../views/Gallery/LoadIn.vue')
  },
  {
    path: '/gallery/interior',
    name: 'Interior Photo Gallery',    
    component: () => import(/* webpackChunkName: "gallery" */ '../views/Gallery/Interior.vue')
  },
  {
    path: '/gallery/interior/back-of-house',
    name: 'Interior Back of House Photo Gallery',    
    component: () => import(/* webpackChunkName: "gallery" */ '../views/Gallery/BackOfHouse.vue')
  },
  {
    path: '/gallery/interior/event-floor',
    name: 'Interior Event Floor Photo Gallery',    
    component: () => import(/* webpackChunkName: "gallery" */ '../views/Gallery/EventFloor.vue')
  },
  {
    path: '/gallery/interior/clubs',
    name: 'Interior Clubs Photo Gallery',    
    component: () => import(/* webpackChunkName: "gallery" */ '../views/Gallery/Clubs.vue')
  },
  {
    path: '/gallery/interior/concourses',
    name: 'Interior Concourses Photo Gallery',    
    component: () => import(/* webpackChunkName: "gallery" */ '../views/Gallery/Concourses.vue')
  },
  {
    path: '/gallery/interior/marketing-assets',
    name: 'Interior Marketing Assets Photo Gallery',    
    component: () => import(/* webpackChunkName: "gallery" */ '../views/Gallery/MarketingAssets.vue')
  },
  {
    path: '/gallery/interior/guest-services',
    name: 'Interior Guest Services Photo Gallery',    
    component: () => import(/* webpackChunkName: "gallery" */ '../views/Gallery/GuestServices.vue')
  },      
  {
    path: '/contact-us',
    name: 'Contact Us',    
    component: () => import(/* webpackChunkName: "home" */ '../views/ContactUs.vue')
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.NODE_ENV === 'production' ? `/entertainment/` : `/`,  
  routes
})

export default router
